import React from 'react';
import { BACKBONE_APP_ROOT } from '@core/js/backbone/constants';

export const BackboneWrapper = ({
    el,
    tagName,
    classes,
    children,
    isHideBackboneClass = false /* Lugano changes */
}) => {

    /* Lugano changes */
    if (tagName === 'span') {
        return (
            isHideBackboneClass
                ? <span ref={el} className={classes}>
                    {children}
                </span>
                : <span className={BACKBONE_APP_ROOT}>
                    <span ref={el} className={classes}>
                        {children}
                    </span>
                </span>
        );
    }

    return (
        isHideBackboneClass
            ? <div ref={el} className={classes}>
                {children}
            </div>
            : <div className={BACKBONE_APP_ROOT}>
                <div ref={el} className={classes}>
                    {children}
                </div>
            </div>
    );
    /* Lugano changes */
};
